import {Component, OnInit, HostListener, ViewChild, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef,
  AfterViewInit } from '@angular/core';
import { JwtService } from '../jwt.service';
import { Router } from '@angular/router';

// import * as moment from 'moment';
import { MenuTab } from './menuTab.interface';
import { Observable, interval, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import moment, { Moment } from 'moment'; // using @types/moment
import { UserService } from '../user.service';
import { UserData } from '../userData';
import { ToplevelMenuItem } from './menuItem.interface';
import { environment } from '../../environments/environment';


import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { UserAuditV2Service } from '../reports/user-audit-updated/user-audit-v2.service';

import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { MccService } from '../mcc.service';

import { memoize } from '../common/memoize-decorator';
import { MatMenuTrigger } from '@angular/material/menu';
import copy from 'copy-to-clipboard';
import { SnackBarComponent } from '../snack-bar/snack-bar.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ClientAccountService } from '../dialogs/client-accounts/client-account.service';
import { EventEmitterService } from '../event-emitter.service';

/** build time */
const buildtime = environment.build_time;
const buildVersion = environment.build_commit;

/** Navigation component: Tabs/Subtabs, footer with Start Menu, content area */
@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss'],
  changeDetection : ChangeDetectionStrategy.OnPush
})

export class NavigationComponent implements OnInit, OnDestroy, AfterViewInit {

  @ViewChild('trigger', {static:false}) contextMenu: MatMenuTrigger;

  contextMenuPosition = { x: '0px', y: '0px' };
  /** detects if timeout countdown is started */
  countdownStarted: boolean;

  /** list of Tabs */
  tabs: MenuTab[] = [];

  activeTabs: MenuTab[] = [];
  /** list of Menu Items */
  topMenu: ToplevelMenuItem[] = [];
  menuButtons: any[] = [];

  /** currentGmtTime */
  currentGmtTime: string;
  /** time of app initialization */
  pageLoaded: Moment;
  /** observable for current time */
  time: Observable<string>;

  /** object contains parameters of a User */
  userData: UserData;

  confirmationDialog: MatDialogRef<any>;

  tpsInterval: any;
  intervalVar;
  timerSubscription: Subscription;

  clickCount = 0;

  chromeTabs = true;

  actualBuild = 'ok';

  /** selectedTabIndex variable */
  selectedTabIndex: number;

  timeoutVar;
  timeoutArray = [];

  filterSubscriptions: Subscription[] = [];

  activeLink = '';

  /** Constructor of class DashboardComponent   */
  constructor(private router: Router,
              private auth: JwtService,
              private matDialogs: MatDialog,
              private mccService: MccService,
              private snackBar: MatSnackBar,
              private eventEmitterService: EventEmitterService,
              public cdr: ChangeDetectorRef, private userService: UserService,
              private clientAccountService: ClientAccountService
              ) {

  }

  @HostListener('window:keydown.esc')
  onEsc() {
    if (this.chromeTabs) {
      const dialog = this.matDialogs.openDialogs[this.matDialogs.openDialogs.length - 1];
      dialog.close(null);
    }
  }

  @HostListener('document:visibilitychange') visibilityChange() {
    if (document.visibilityState === 'hidden') {
      if (this.timerSubscription) {
        this.timerSubscription.unsubscribe();
      }
    } else {
      this.refreshToken();
    }
  }

  @memoize()
  getBuiltTime() {
    return buildtime;
  }

  @memoize()
  getVersion() {
    return buildVersion;
  }

  drop(event: CdkDragDrop<string[]>, tab) {
    moveItemInArray(tab.subtabs, event.previousIndex, event.currentIndex);
  }

  refreshToken() {
    const exp = this.auth.getExpiration();
    if (exp < moment()) {
      const tm = setTimeout(() => {
        this.auth.refreshToken().toPromise().then(() => {
          clearTimeout(tm);
        });
      }, 1000);
    }
  }

  onContextMenu(event: MouseEvent, subItem) {
    event.preventDefault();
    this.contextMenuPosition.x = event.clientX + 'px';
    this.contextMenuPosition.y = event.clientY + 'px';
    this.contextMenu.menuData = { item: subItem };
    /* this.contextMenu.menu.focusFirstItem('mouse'); */
    this.contextMenu.openMenu();
  }

  versionCheck(time) {

    this.actualBuild = 'ok';
    if (this.timeoutVar) {
      clearTimeout(this.timeoutVar);
    }

  }

  ngAfterViewInit() {
    this.versionCheck(0);
  }

  showDialogs(tabCode: string) {
    this.matDialogs.openDialogs.forEach(element => {
      if (element.id.indexOf(tabCode) > -1 ) {
        element.removePanelClass('hidden_dialog');
      }
    });
  }

  async hideDialogs(tabCode: string) {
    this.matDialogs.openDialogs.forEach(element => {
      if (element.id.indexOf(tabCode) > -1 ) {
        element.addPanelClass('hidden_dialog');
      }
    });
  }

  navigate(path) {
    this.activeLink = path;
    const link = 'panel/' + path;
    /* this.router.navigate([]).then(result => {  window.open(link, '_blank'); }); */
    this.router.navigate([link]);
  }

  async setCommonSubscriptions() {
    // this.userService.getUserList();
    this.mccService.getCountriesList('country');
    // this.clientService.getClientsList();
  }

  /** Actions that would be executed on initialization of component   */
  ngOnInit() {
    this.intervalVar = setInterval(() => this.refreshToken(), 300000);

    this.clientAccountService.getClientID().toPromise().then((res: any) => {
      if (res && res.body.client_id !== -1) {
        this.userService.setUserData(res.body);
      }
    });

    this.setCommonSubscriptions();

    this.time = interval(1000).pipe( // why you need 1s interval with HH:mm time format simply update it every minute not every second.
      map(() => {
        this.pageLoaded = moment().utc(); // you need the value of now not the value of the initialized time.
        return this.pageLoaded.format('Do [of] MMMM YYYY, LTS'); //29th of May 2021, 6:26:28 AM | MMMM Do YYYY
      })
    );

/*     this.userService.me().toPromise().then((data: any) => {
      this.userData = data;
      this.userAuditV2Service.setUsersID(this.userData.id);

    }).catch(err => {
      if (err.statusText === 'Unauthorized') {
        this.router.navigate(['/']);
      }
    }); */

    if (this.eventEmitterService.subsVar === undefined) {
      this.eventEmitterService.subsVar = this.eventEmitterService.
      invokeNavigationFunction.subscribe((data) => {
        if (data) {
          this.navigate(data.link);
        }
      });
    }

    this.navigate('dlr_policies');

    this.filterSubscriptions.push(this.userService.getUserDataObservable().subscribe(r => {
      this.userData = r;
      this.cdr.detectChanges();
    }));

  }

  copyTime() {
    copy('Platform time: ' + this.pageLoaded.format('Do [of] MMMM YYYY, LTS') + ' (GMT)');
    this.openSnackBar(['+Datetime copied to clipboard']);
  }

  openSnackBar(message: Array<string>) {
    // this.snackBar.open(message);
    this.snackBar.openFromComponent(SnackBarComponent, {
      data: message
    });
  }

  /**  Logout Method   */
  logOut() {
    this.auth.logout();
    this.router.navigate(['/']);
/*     const ap = {
      comment: 'user log out'
    };
    this.userAuditV2Service.createAuditRecord('Logout', 'insert', JSON.stringify(ap)).then(rr => {
      this.auth.logout();
      this.router.navigate(['/']);
    });  */

  }


  /** returns GMT time */
  getGMTTime() {
    this.currentGmtTime = 'GMT : ' + moment().utc().format('MM-DD-YYYY LTS');
    return this.currentGmtTime;
  }

  /** destroy subscriptions in the end of component lifecycle */
  ngOnDestroy() {
    if (this.eventEmitterService.subsVar) {
      this.eventEmitterService.subsVar.unsubscribe();
    }

    this.timeoutArray.forEach(element => {
      if (element) {
        clearTimeout(element);
      }
    });

    if (this.timeoutVar) {
      clearTimeout(this.timeoutVar);
    }
    if (this.intervalVar) {
      clearInterval(this.intervalVar);
    }

    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
    }

    this.timeoutArray.forEach(el => {
      clearTimeout(el);
    });
    if (this.tpsInterval) {
      clearInterval(this.tpsInterval);
    }
  }

}

